







































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Dictionary } from "vuex";
import ApiFactory from "@/api/ApiFactory";
import { UserStore, LoadingSpinnerService } from "@/store";

@Component
export default class FundManagerMixChart extends Vue {
  @Prop() policyId: number | undefined;
  @Prop() contactId: number | undefined;
  @Prop() id: number | undefined;

  private fundMixData: Dictionary<number> | null = null;
  private fundMixOptions = {
    tooltip: {
      trigger: "none"
    },

    hAxis: {
      format: "percent"
    }
  };

  async mounted() {
    await this.getFundMix();
  }

  private async getFundMix() {
    if (!this.contactId || !this.id) throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    this.fundMixData = await api.funds_GetFundManagerMix(
      UserStore.profileId,
      3,
      this.id
    );
    // this.fundMixData = {
    //   "Irish Life": 20,
    //   Zurich: 40,
    //   "New Ireland": 30,
    //   "Standard Life": 10
    // };
  }
}
